import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useUserInfor } from "../../../../../../../Context/User";
import { AtualizarConfigGeralController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import UnForm from "../../../../../../Form";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { ListarEtapasPorTipoCasoController } from "../../../../../../../Controllers/Geral/Etapas/EtapasControllers";
import Swal from "sweetalert2";
import { IConfigGeral_Vistoria } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import { IConfigGeralModulos } from "../../../../../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";
import { GetConfigModuloController } from "../../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";

interface IVistoriaEntregaChavesConfig {
    lstConfigModulo: IConfigGeralModulos[] | undefined;
    AtualizarConfigModulo: (requestBody: IConfigGeralModulos) => Promise<any>;
    ListConfigModulo: (...args: any[]) => Promise<IConfigGeralModulos[]>;
}

export default function VistoriaEntregaChavesConfig(
    props: IVistoriaEntregaChavesConfig
) {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigVistoriaDTO;

    const idModuloVistoria = props.lstConfigModulo?.find(
        (lst) => lst.ID_MODULO === 10
    );

    const { value: getConfigModulo } = useAsyncEffect(async () => {
        if (idModuloVistoria) {
            return GetConfigModuloController(idModuloVistoria.ID_MODULO);
        }
    }, [idModuloVistoria]);

    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigVistoriaDTO: {
                ...config,
            },
            FL_ENVIO_HORARIOS_DISPONIVEIS: Config.FL_ENVIO_HORARIOS_DISPONIVEIS,
        }).then(() => {
            updateConfig();
        });
    }

    const { execute: listarEtapasPorTipoCaso } = useAsyncCallback(
        () => ListarEtapasPorTipoCasoController(10),
        []
    );

    const handleSubmit = (formValue: IConfigGeral_Vistoria) => {
        config.ID_RETORNO_ETAPA_CASO =
            formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                ? formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                : 0;
        if (formValue.NR_AGENDAMENTOS_HORARIO > 0) {
            Config.ConfigVistoriaDTO.NR_AGENDAMENTOS_HORARIO =
                formValue.NR_AGENDAMENTOS_HORARIO;
            update();
        } else {
            Swal.fire({
                title: `Somente números positivos são permitidos!`,
                icon: "info",
                confirmButtonText: "<i class='la la-check'></i> Ok!",
                customClass: {
                    confirmButton: "btn btn-outline-success",
                },
                timer: 5000,
            });
        }
    };

    // const handleSubmit = (formValue: any) => {
    //     config.ID_RETORNO_ETAPA_CASO =
    //         formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
    //             ? formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
    //             : 0;
    //     update();
    // };

    return (
        <>
            <div className="col-12 mb-4">
                <h4>Abrir novo atendimento</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Abrir novo atendimento ao receber resposta do cliente no
                        email de finalização do caso.
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        getConfigModulo?.ConfigModuloCampo
                                            .FL_CRIAR_ATEND_RESPOSTA_EMAIL
                                    }
                                    onChange={(e) => {
                                        props
                                            .AtualizarConfigModulo({
                                                ConfigModuloCampo: {
                                                    FL_CRIAR_ATEND_RESPOSTA_EMAIL:
                                                        Boolean(
                                                            e.target.checked
                                                        ),
                                                },
                                                ID_MODULO:
                                                    getConfigModulo?.ID_MODULO ??
                                                    0,
                                            })
                                            .then(() => {
                                                props.ListConfigModulo();
                                                updateConfig();
                                            });
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className="col-12 mb-4">
                <h4>Produto por Grupo</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir Selecionar o Produto de acordo com o Grupo?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config?.FL_SEGURANCA_GRUPO_PRODUTO_VISTORIA
                                    }
                                    onChange={() => {
                                        config.FL_SEGURANCA_GRUPO_PRODUTO_VISTORIA =
                                            !config.FL_SEGURANCA_GRUPO_PRODUTO_VISTORIA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-column mb-4">
                    <label className="col-12 col-form-label px-0">
                        Envio de link com horários disponíveis.
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        Config?.FL_ENVIO_HORARIOS_DISPONIVEIS
                                    }
                                    onChange={() => {
                                        Config.FL_ENVIO_HORARIOS_DISPONIVEIS =
                                            !Config.FL_ENVIO_HORARIOS_DISPONIVEIS;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <h4>Reiniciar Caso e Agendamentos</h4>
            </div>

            <UnForm handleSubmit={handleSubmit}>
                <div className="d-flex align-items-center">
                    <>
                        <div className="col-6">
                            <UnForm.LazySelect
                                getDS={(je) =>
                                    je.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                }
                                getKeyValue={(je) =>
                                    je.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                }
                                controller={listarEtapasPorTipoCaso}
                                name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                label="Insira uma Etapa Categoria Atendimento"
                                defaultValue={config.ID_RETORNO_ETAPA_CASO}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        <div className="col-6">
                            <label>
                                Quantidade de clientes que podem realizar
                                vistoria no mesmo horário
                            </label>
                            <UnForm.Input
                                name="NR_AGENDAMENTOS_HORARIO"
                                type={"number"}
                                defaultValue={
                                    Config.ConfigVistoriaDTO
                                        .NR_AGENDAMENTOS_HORARIO
                                }
                                registerOptions={{
                                    required: "Insira uma quantidade",
                                }}
                            />
                        </div>
                    </>
                </div>
                <div className="col-12">
                    <label></label>
                    <UnForm.SubmitButton
                        color="success"
                        icon={faPaperPlane}
                        loadingSize="sm"
                    >
                        Atualizar
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </>
    );
}
